import FormConfig from '../ConfigurationFormConfig';
import AjaxUtility from '../../Utility/AjaxUtility';
import RainwaterSelectionMap from "../RainwaterSelectionMap";
import RainwaterSelectionMapAt from "../RainwaterSelectionMapAt";

export default class LocationManager {

	/**
	 * @param {jQuery} form - Das Formular-Element
	 * @param {Object} sharedState - Gemeinsames State-Objekt (muss { country: ... } enthalten)
	 */
	constructor(form, sharedState) {
		this.form = form;
		this.state = sharedState;

		// Wichtige DOM-Elemente cachen
		this.weatherStation = $(FormConfig.selectors.weatherStation);
		this.rcIndexInput = $(FormConfig.selectors.rcIndexInput);
		this.propertyZipInput = $(FormConfig.selectors.propertyZipInput);
		this.propertyCityInput = $(FormConfig.selectors.propertyCityInput);
		this.citySelect = $(FormConfig.selectors.citySelect);
		this.changeWeatherStationBtn = $(FormConfig.selectors.changeWeatherStation);
		this.resultMessageContainer = $(FormConfig.selectors.weatherStationCheckResult);

		// Local state
		this.rainwaterSelectionMap = null;
		this.rcIndex = this.rcIndexInput.val();
		this.initialMapGridSet = false;

		this.bindEvents();

		// Initial checks on load
		this.init();
	}

	init() {
		if (this.propertyZipInput.val() === '') {
			this.changeWeatherStationBtn.hide();
		}

		// Falls beim Laden keine Wetterstation/Index da ist, aber eine PLZ existiert -> Checken
		if (!this.rcIndex || this.rcIndex === '') {
			if (this.propertyZipInput.length && this.propertyZipInput.val() !== '') {
				const ajaxFinished = this.checkWeatherStation(this.propertyZipInput.val(), FormConfig.selectors.propertyCityDisplay);

				if (ajaxFinished) {
					ajaxFinished.done(() => this.showManualWeatherStation());
				}
			}
		}
	}

	bindEvents() {
		// 1. Länderwahl
		const countryRadios = $(FormConfig.selectors.country);
		countryRadios.on('click', e => {
			this.countryChange(parseInt(e.target.value));
		});

		// Initialen State aus dem DOM lesen (falls Radio schon checked)
		const currentCountry = countryRadios.filter(':checked').val();
		if (currentCountry) {
			this.countryChange(parseInt(currentCountry), false);
		}

		// 2. PLZ Eingabe & Wetterstation Check
		this.propertyZipInput.on('blur', e => {
			if (this.state.country === FormConfig.values.countries.GERMANY) {
				this.checkWeatherStation(e.target.value, FormConfig.selectors.propertyCityDisplay);
			}
		});

		this.propertyZipInput.on('change', () => {
			this.resetWeatherStationCheck();
		});

		// 3. Manuelle Wetterstation wählen
		this.changeWeatherStationBtn.on('click', e => {
			e.preventDefault();
			this.setWeatherStationManually();
		});
	}

	/**
	 * Hauptlogik für Länderwechsel (DE, AT, CH, etc.)
	 */
	countryChange(country, setDefaultValues = true) {
		this.state.country = country; // Update Shared State

		// Get current element states
		const $weatherStation = $(FormConfig.selectors.weatherStation);
		const $cityDisplay = $(FormConfig.selectors.propertyCityDisplay);

		// Logik für Regenhäufigkeit (Frequency) Dropdown
		this.updateRainFrequencyOptions(country, setDefaultValues);

		// guidelines logic (also see ConfigurationForm -> infiltrationTypeChange)
		// force all countries except germany into legacy guideline
		if (country !== FormConfig.values.countries.GERMANY) {
			// preselect legacy guideline and disable guidelines selection for other countries
			$(FormConfig.selectors.legacyGuidelineRadio).click();
			$(FormConfig.selectors.legacyGuidelineRadio).parents(FormConfig.selectors.slides).data('skip', true);
		} else {
			$(FormConfig.selectors.legacyGuidelineRadio).parents(FormConfig.selectors.slides).data('skip', false);
		}

		// VSOAT-55: Stop at this point, if country is Austria. Do not change weather station selection or hide any options
		if (country === FormConfig.values.countries.AUSTRIA) {
			$cityDisplay.hide();
			this.propertyCityInput.show();
			this.changeWeatherStationBtn.hide();

			// initialise geocoder right away for Austrian map implementation
			const script = document.createElement('script');
			script.async = true;
			script.src = "https://maps.googleapis.com/maps/api/js?key=AIzaSyDYhLdncbls5waHK0XTBHzZ8YPK88aTMUk&loading=async&callback=initGeocoder";
			document.body.appendChild(script);

			return;
		}

		// Logik für Deutschland vs. Andere
		if (country === FormConfig.values.countries.GERMANY) {
			// return to default
			$weatherStation.show();
			$cityDisplay.show();
			this.propertyCityInput.hide();
			if (this.propertyZipInput.val() !== '') {
				this.changeWeatherStationBtn.show();
			}
		} else {
			// switch to new mode
			$weatherStation.hide();
			$cityDisplay.hide();
			this.propertyCityInput.show();
			this.changeWeatherStationBtn.hide();

			if (this.rainwaterSelectionMap) {
				this.rainwaterSelectionMap.hide();
			}
		}
	}

	/**
	 * Passt die Auswahlmöglichkeiten im Dropdown "Regenhäufigkeit" an das Land an
	 */
	updateRainFrequencyOptions(country, setDefaultValues = true) {
		const indexDefaultFrequency = 3;   // 5 Jahre
		const indexDefaultFrequencyCh = 4; // 10 Jahre
		const index15years = 5;
		const index50years = 8;
		const index100years = 9;

		// Manipulate rain frequency select for CH
		const rainFrequencySelect = $(FormConfig.selectors.rainFrequencySelect)[0];
		if (!rainFrequencySelect) return;

		// Get select options
		const rainFrequencyOptions = rainFrequencySelect.options;
		const defaultOptionText = rainFrequencySelect.dataset.defaultOptionText || '';

		// Default: hide 15 years and show 50 and 100 years
		let hideOptions = [index15years];
		let showOptions = [index50years, index100years];
		// Default selected value = 5 years
		let defaultValue = 5;
		// Add default text to 5 years (option 3) and remove from 10 years (option 4, if set by CH)
		let addDefaultTextIndex = indexDefaultFrequency;
		let removeDefaultTextIndex = indexDefaultFrequencyCh;

		if (country === FormConfig.values.countries.SWITZERLAND) {
			hideOptions = [index50years, index100years];
			showOptions = [index15years];
			defaultValue = 10;
			addDefaultTextIndex = indexDefaultFrequencyCh;
			removeDefaultTextIndex = indexDefaultFrequency;
		}

		// Set current default (selected) value for select
		if (setDefaultValues) {
			rainFrequencySelect.value = defaultValue;
		}

		// Add and remove default text
		if (rainFrequencyOptions[addDefaultTextIndex].innerHTML.indexOf(defaultOptionText) === -1) {
			rainFrequencyOptions[addDefaultTextIndex].innerHTML += defaultOptionText;
		}
		if (rainFrequencyOptions[removeDefaultTextIndex].innerHTML.indexOf(defaultOptionText) !== -1) {
			rainFrequencyOptions[removeDefaultTextIndex].innerHTML = rainFrequencyOptions[removeDefaultTextIndex].innerHTML.replace(defaultOptionText, '');
		}

		// Show/hide rainFrequencyOptions based on selected country
		hideOptions.forEach(idx => { if(rainFrequencyOptions[idx]) rainFrequencyOptions[idx].setAttribute('hidden', 'hidden'); });
		showOptions.forEach(idx => { if(rainFrequencyOptions[idx]) rainFrequencyOptions[idx].removeAttribute('hidden'); });
	}

	/**
	 * Find the matching weather station
	 * (this should probably be a separate object)
	 *
	 * @param submitForm
	 * @param displayInputId
	 * @param zip
	 */
	checkWeatherStation(zip, displayInputId, submitForm = false) {
		if (this.state.country !== FormConfig.values.countries.GERMANY) {
			return;
		}

		const weatherStationCheckLoading = $(FormConfig.selectors.weatherStationCheckLoading);
		const cityInput = $(FormConfig.selectors.cityInput); // Hidden input für ID
		const displayInput = $(displayInputId);

		weatherStationCheckLoading.show();

		if (!zip && this.propertyZipInput.length) {
			zip = this.propertyZipInput.val();
		}

		return AjaxUtility.request('Configurator', {
			controller: 'Configuration',
			action: 'checkWeatherStation',
			zip: zip
		}).done(response => {
			const data = JSON.parse(response);
			const message = data.message;
			const city = data.city;

			this.rcIndex = data.rcIndex; // State update
			// Keep hidden input in sync for validation and backend submission
			this.rcIndexInput.val(this.rcIndex).trigger('change');

			this.resultMessageContainer.html(message);
			this.resultMessageContainer.toggle(message.length > 0);
			this.resultMessageContainer.toggleClass('error', data.error);
			weatherStationCheckLoading.hide();

			// set result if it was unambiguous
			if (city.uid !== undefined) {
				this.citySelect.html(`<option value="${city.uid}">${city.name}</option>`);
				this.citySelect.val(city.uid);

				if (displayInputId === FormConfig.selectors.propertyCityDisplay) {
					this.propertyCityInput.val(city.name);
				}
				if (displayInputId) {
					displayInput.val(city.name + '**');
				}

				cityInput.prop('required', false);

				if (submitForm) {
					this.form.submit();
				}

				if (this.rainwaterSelectionMap) {
					this.rainwaterSelectionMap.setViewToGridFeature(this.rcIndex);
					this.rainwaterSelectionMap.selectByRcIndex(this.rcIndex);
					this.rainwaterSelectionMap.show();
					this.resultMessageContainer.hide();
				} else {
					this.resultMessageContainer.show();
				}
			} else {
				// reset values
				this.citySelect.val(null);
				this.changeWeatherStationBtn.hide();
			}
		});
	}

	showManualWeatherStation() {
		const cityInput = $(FormConfig.selectors.cityInput);
		if (cityInput.length > 0 && cityInput.val().length > 0 &&
			this.citySelect.length > 0 && this.citySelect[0].options.length === 0) {

			cityInput.addClass('error');
			$(FormConfig.selectors.manualWeatherStationSelection).show();
		}
	}

	resetWeatherStationCheck() {
		this.resultMessageContainer.hide();
	}

	setWeatherStationManually() {
		this.changeWeatherStationBtn.hide();
		this.resultMessageContainer.hide();

		if (!this.rainwaterSelectionMap) {
			if (this.state.country === FormConfig.values.countries.AUSTRIA) {
				this.rainwaterSelectionMap = new RainwaterSelectionMapAt();
			} else if(this.state.country === FormConfig.values.countries.GERMANY) {
				this.rainwaterSelectionMap = new RainwaterSelectionMap();
			}
		}

		if (this.rainwaterSelectionMap) {
			if (this.state.country === FormConfig.values.countries.AUSTRIA || this.state.country === FormConfig.values.countries.GERMANY) {
				this.rainwaterSelectionMap.show();
				// Resize-fix
				setTimeout(() => {
					window.dispatchEvent(new Event('resize'));
				}, 200);

				// Map Initialisierung (Zoom auf Grid/Home)
				if (this.rcIndex && !this.initialMapGridSet) {
					if (this.state.country === FormConfig.values.countries.AUSTRIA) {
						this.rainwaterSelectionMap.getNewHomeLocation();
					} else if(this.state.country === FormConfig.values.countries.GERMANY) {
						this.rainwaterSelectionMap.setViewToGridFeature(this.rcIndex);
						this.rainwaterSelectionMap.selectByRcIndex(this.rcIndex);
					}
					this.initialMapGridSet = true;
				}
			} else {
				this.rainwaterSelectionMap.hide();
			}
		}

		$(FormConfig.selectors.propertyCityDisplay).hide();
		this.propertyCityInput.show();
	}

	validateZip(field, errors) {
		// Zugriff auf State country
		const country = this.state.country;

		switch (country) {
			case FormConfig.values.countries.GERMANY:
				if(!field.value.match(/^\d{5}$/)) {
					return this.addError(field, errors);
				}
				return true;
			case FormConfig.values.countries.NETHERLANDS:
				if(!field.value.match(/^\d{4}\s?\w{2}$/)) {
					return this.addError(field, errors);
				}
				return true;
			default:
				if(!field.value.match(/^\d{4}$/)) {
					return this.addError(field, errors);
				}
				return true;
		}
	}

	validateRcIndex(field, errors) {
		if(this.rcIndexInput.val() === '') {
			return this.addError(field, errors, $(field).data('rcindexmissing'));
		}
	}

	// Helper for validation errors
	addError(field, errors, errorMsg = null) {
		errors[field.name] = {
			message: errorMsg || $(field).data('validationmessage') || field.validationMessage
		}
		$(field).addClass('error');
		return false;
	}
}
